import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import * as api from "api/Core";
import { RequestIndicator } from "components/CallServer";
import MuiLink from "components/MuiExtras/MuiLink";
import { GetAgreementDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onChange: (checked: boolean) => void;
    onNoAgreementFound?: () => void;
}

interface IState {
    data: GetAgreementDto;
    loading: boolean;
    lastError: any;
    checked: boolean;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class AgreementComponent extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: false,
            lastError: null,
            checked: false
        };
    }

    ///
    private load() {
        this.setState({ data: null, loading: true });

        api.getAgreement()
            .then((result) => {
                console.log(result);
                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, lastError: error, loading: false });
            });
    }

    ///
    public componentDidMount() {
        this.load();
    }

    ///
    private renderSimpleText() {
        return <b>{this.props.t("Views.System.Components.Agreement.HeaderTitle")}</b>;
    }

    private renderTextTerm() {
        const { data: { text } } = this.state;

        return (
            <div style={{ minHeight: "20rem", maxHeight: "20rem", overflowY: "auto", marginTop: "1rem", padding: "0.4rem", border: "1px solid grey" }} dangerouslySetInnerHTML={{ __html: text }} />
        );
    }

    ///
    private renderLink() {
        const { data: { file } } = this.state;

        return (
            <MuiLink href={file.url} target="_blank">
                {this.renderSimpleText()}
            </MuiLink>
        );
    }

    ///
    public render() {
        const { data, loading, checked } = this.state;

        if (loading) {
            return <RequestIndicator type="waiting" />;
        }

        if (data == null) {
            if (this.props.onNoAgreementFound) this.props.onNoAgreementFound();
            return null;
        }

        return (
            <>
                {
                    data.file && data.text == null
                        ? this.renderLink()
                        : this.renderTextTerm()
                }
                <Grid container alignItems="center" >
                    <Grid item xs>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="agreement"
                                    checked={checked}
                                    onChange={
                                        (e) => {
                                            this.setState({ checked: (e.target as HTMLInputElement).checked });
                                            this.props.onChange((e.target as HTMLInputElement).checked);
                                        }
                                    }
                                    value="agreement" />
                            }
                            label={<span>{this.props.t("Views.System.Components.AgreementCheckbox.Label")}</span>}
                        />
                    </Grid>
                    {
                        data.file &&
                        <Grid item>
                            <MuiLink href={data.file.url} target="_blank">
                                <FontAwesomeIcon icon={faDownload} size="2x" />
                            </MuiLink>
                        </Grid>
                    }
                </Grid>
            </>
        );
    }
}

export default withTranslation()(AgreementComponent);
